module.exports = __webpack_public_path__ + "media/applicants/hqdefault-5c4ad127.jpg";